import { render, staticRenderFns } from "./lookPopup.vue?vue&type=template&id=2d2fb116"
import script from "./lookPopup.vue?vue&type=script&lang=js"
export * from "./lookPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports